document.addEventListener('DOMContentLoaded', () => {
    var clickEvent = (evt) => {
        evt.preventDefault();
        evt.target.parentNode.classList.toggle('open');
    };

    if (document.querySelector('.product-info__title') != null) {
        document.querySelectorAll('.product-info__title').forEach(function (e) {
            e.addEventListener('click', clickEvent);
        });
    }

    // Products sold in packs (2-pack, 4-pack, ...) render step="<pack size>" so the stepper
    // moves a whole pack at a time. Everything else keeps the old step of 1.
    var getStep = (input) => {
        var step = parseInt(input.getAttribute('step'));
        return isNaN(step) || step < 1 ? 1 : step;
    };

    var syncStepperDisabled = (wrapper) => {
        var decrease = wrapper.querySelector('.product-detail__quantity-decrease, .minus');
        var increase = wrapper.querySelector('.product-detail__quantity-increase, .plus');
        var input = wrapper.children[1];
        if (!input) return;
        var value = parseInt(input.value);
        var max = parseInt(input.getAttribute('max'));
        var min = parseInt(input.getAttribute('min'));
        var step = getStep(input);
        if (isNaN(max)) max = Infinity;
        if (isNaN(min)) min = 0;
        if (decrease) decrease.disabled = value - step < min;
        if (increase) increase.disabled = value + step > max;
    };

    var clickEvent2 = (evt) => {
        if(evt.target.classList.contains('plus') || evt.target.classList.contains('product-detail__quantity-increase')){

            var input = evt.currentTarget.children[1];
            var value = parseInt(input.value);
            var max = parseInt(input.getAttribute('max'));
            var step = getStep(input);
            if (isNaN(max)) { max = Infinity; }

            if (value + step <= max) {
                var next = value + step;
                input.value = next;
                input.setAttribute('value', next);
            }
            syncStepperDisabled(evt.currentTarget);

        } else if(evt.target.classList.contains('minus') || evt.target.classList.contains('product-detail__quantity-decrease')){
            var input = evt.currentTarget.children[1];
            var value = parseInt(input.value);
            var min = parseInt(input.getAttribute('min'));
            var step = getStep(input);
            if (isNaN(min)) { min = 0; }

            if (value - step >= min) {
                var prev = value - step;
                input.value = prev;
                input.setAttribute('value', prev);
            }
            syncStepperDisabled(evt.currentTarget);
        }
    };

    if(document.querySelector('.qty_container') != null) {
        document.querySelectorAll('.qty_container').forEach(function(e){
            e.addEventListener('click', clickEvent2);
        });
    }
    
    if(document.querySelector('.product-detail__quantity-wrapper') != null) {
        document.querySelectorAll('.product-detail__quantity-wrapper').forEach(function(e){
            e.addEventListener('click', clickEvent2);
        });
    }

    var clickEvent3 = (evt) => {
        var children = evt.currentTarget.parentNode.children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if(child.classList.contains('hidden')){
                while(child.childNodes.length > 0){
                    evt.currentTarget.parentNode.appendChild(child.childNodes[0]);
                }
                child.remove();
            }
        }
        
        evt.currentTarget.remove();
    }

    setTimeout(() => {
        if(document.querySelector('.showmore') != null){
            document.querySelectorAll('.showmore').forEach(function(e){
                e.addEventListener('click', clickEvent3);
            });
        }
    }, 1000);

    var opened = false;

    var clickVariant = (event) => {
        var target = event.currentTarget.parentNode;
        if (!opened) {
            target.lastElementChild.style.display = 'block';
            setTimeout(() => {
                    opened = true;
                },
                10);
        } else {
            target.lastElementChild.style.display = 'none';
            opened = false;
        }
    }


    if(document.getElementById('variants') != null){
        document.getElementsByTagName('html')[0].addEventListener('click', function(evt){

            if(!evt.target.classList.contains('variants') && opened){
                document.querySelectorAll('.variants-holder .variants').forEach(function(e){
                    e.style.display = 'none';
                    opened = false;
                });
            }
        });

        document.querySelectorAll('#variants .has-variants').forEach(function(e){
            e.addEventListener('click', clickVariant);
        });
    }
});